import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";

import { faq_header, faq_question, terms_data } from "./data";

const FaqContent = () => {
  const [head_state, setHead_state] = useState("Validating an Account");
  const [openQuestionId, setOpenQuestionId] = useState<number | null>(null);

  const toggleQuestion = (id: number) => {
    setOpenQuestionId(openQuestionId === id ? null : id);
  };

  const handle_head_state = (state: string) => setHead_state(state);
  return (
    <Box
      sx={{
        py: 1,
        px: 2,
      }}
    >
      <Stack
        direction={"row"}
        alignItems={"center"}
        sx={{ my: 2, overflowX: "auto" }}
      >
        {faq_header?.map((header, index) => (
          <Typography
            variant="body2"
            sx={{
              color: head_state === header ? "#000" : "#7991A4",
              mx: 1,
              py: "4px",
              fontWeight: 500,
              cursor: "pointer",
              borderBottom: head_state === header ? "1px solid #459173" : "",
            }}
            onClick={() => handle_head_state(header)}
          >
            {header}
          </Typography>
        ))}
      </Stack>

      <Box sx={{ my: "3rem" }}>
        {faq_question.map((faq) => (
          <Box
            key={faq.id}
            sx={{
              my: 2,
              border: openQuestionId === faq.id ? "1px solid #B6C3CD" : "",
              background: "#FFFFFF",
              borderRadius: "14px",
              p: 1,
            }}
          >
            <Box
              onClick={() => toggleQuestion(faq.id)}
              style={{
                width: "100%",
                textAlign: "left",
                padding: "1rem",
                cursor: "pointer",
              }}
            >
              <Typography sx={{ color: "#0A0B0A", fontWeight: 500, }}>
                {faq.question}
              </Typography>
            </Box>
            {openQuestionId === faq.id && (
              <Box
                sx={{
                  p: 2,
                  borderTop: "none",
                  backgroundColor: "#fff",
                  fontSize: '14px',
                }}
              >
                {faq.answer}
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FaqContent;
